const phone = (cellphone: string) => {
  const cleanedPhone = cellphone ? cellphone.replace(/\D/g, '') : ''
  const phoneDDD = cleanedPhone.slice(0, 2)
  const phoneWithoutDDD = cleanedPhone.slice(2)
  const isTollFreePhone = cleanedPhone.startsWith('0800')
  const isInvalidInitialPhone = /^[01]/.test(phoneWithoutDDD) || /^[0]/.test(cleanedPhone)
  const isLocalPhone = /^[2-5]/.test(phoneWithoutDDD)
  const isMobilePhone = /^9\d{8}$/.test(phoneWithoutDDD)
  const isMobilePhoneSaoPaulo = /^9[1-9][0-9]{7}$/.test(phoneWithoutDDD)

  return {
    cleanedPhone,
    isTollFreePhone,
    isLocalPhone,
    isMobilePhone,
    phoneWithoutDDD,
    phoneDDD,
    isInvalidInitialPhone,
    isMobilePhoneSaoPaulo,
  }
}

export { phone }
